import { useCallback, useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

/** Suivi « consentement signé reçu » par athlète mineur + rappels parents préparés dans la Boîte d'envoi (approbation requise). */
export const ConsentBar = ({ eventId, refreshKey }) => {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const load = useCallback(async () => {
    try { const r = await api.get(`/mini-competitions/${eventId}/consents`); setD(r.data); } catch { /* silencieux */ }
  }, [eventId]);
  useEffect(() => { load(); }, [load, refreshKey]);
  const remind = async (channel) => {
    if (!window.confirm(`Préparer un rappel ${channel === "both" ? "courriel + SMS" : channel === "sms" ? "SMS" : "courriel"} pour ${d.missing} parent(s) sans consentement signé ? Les messages iront dans la Boîte d'envoi — rien n'est envoyé sans ton approbation.`)) return;
    setBusy(true);
    try { const r = await api.post(`/mini-competitions/${eventId}/consents/remind`, { channel }); toast.success(r.data.message); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); } finally { setBusy(false); }
  };
  if (!d) return null;
  return (
    <div className={`rounded-xl border p-3 text-xs flex flex-wrap items-center gap-3 ${d.missing ? "border-amber-500/40 bg-amber-500/5" : "border-emerald-500/40 bg-emerald-500/5"}`} data-testid="jm-consent-bar">
      <div>
        <div className="text-[10px] tracking-[0.3em] text-amber-400">CONSENTEMENTS SIGNÉS — MINEURS</div>
        <div className="text-zinc-300 mt-0.5">
          <b data-testid="consent-minors">{d.minors}</b> mineur(s) · <b className="text-emerald-300" data-testid="consent-received">{d.received}</b> reçu(s) · <b className={d.missing ? "text-red-300" : "text-zinc-400"} data-testid="consent-missing">{d.missing}</b> manquant(s)
          <span className="text-zinc-500"> — coche la case « Consentement » dans le tableau quand le formulaire signé est en main. Rappel automatique hebdomadaire (événement ouvert) préparé dans la Boîte d'envoi.</span>
        </div>
      </div>
      {d.missing > 0 && (
        <div className="ml-auto flex gap-2">
          <button disabled={busy} onClick={() => remind("email")} className="px-3 py-1.5 rounded-lg bg-amber-600 hover:bg-amber-500 text-black font-semibold" data-testid="consent-remind-email">📨 Rappel courriel ({d.missing})</button>
          <button disabled={busy} onClick={() => remind("sms")} className="px-3 py-1.5 rounded-lg border border-zinc-700 text-zinc-300 hover:border-amber-500/50" data-testid="consent-remind-sms">📱 Rappel SMS</button>
        </div>
      )}
    </div>
  );
};

export const ConsentCheck = ({ eventId, reg, onChanged }) => {
  const [busy, setBusy] = useState(false);
  if ((reg.athlete_age_at_event ?? 99) >= 18) return <span className="text-zinc-600 text-[10px]">Majeur</span>;
  const cs = reg.consent_signed || {};
  const toggle = async () => {
    setBusy(true);
    try { await api.patch(`/mini-competitions/${eventId}/registrations/${reg.id}/consent`, { received: !cs.received, note: cs.note || "" }); toast.success(!cs.received ? "Consentement signé reçu ✔" : "Consentement retiré"); onChanged?.(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); } finally { setBusy(false); }
  };
  return (
    <label className="inline-flex items-center gap-1.5 cursor-pointer whitespace-nowrap" title={cs.received ? `Reçu le ${String(cs.at).slice(0, 10)} · ${cs.by || ""}` : reg.consent_last_reminder_at ? `Dernier rappel ${String(reg.consent_last_reminder_at).slice(0, 10)} (${reg.consent_reminders || 0})` : "Formulaire signé non reçu"}>
      <input type="checkbox" checked={!!cs.received} disabled={busy} onChange={toggle} className="accent-emerald-500" data-testid={`consent-check-${reg.id}`} />
      <span className={cs.received ? "text-emerald-300 text-[11px]" : "text-red-300 text-[11px]"}>{cs.received ? "Reçu" : "Manquant"}</span>
      {!cs.received && reg.consent_reminders > 0 && <span className="text-[10px] text-zinc-500">↻{reg.consent_reminders}</span>}
    </label>
  );
};
